import React from 'react';

import ReassignUserTasks from "../reassign-items/tasks";
import ReassignUserEvents from "../reassign-items/events";
import ReassignUserProjects from "../reassign-items/projects";
import VScroll from "../../../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll";
import Form from "../../../../../../core/gd-form/form/form-ui5/form";
import ProjectSession from "../../../../../model2/project/project-session";
import User from "../../../../../model2/user/user";
import {ReassignToUserType, USER_VIEW_TYPE} from "../../../@type";
import UserIcon from "../../../../../gd-components/icons/user/user";
import ButtonSubmit from "../../../../../gd-form/common/btn-submit/btn-submit-ui5-new";
import Button, {ButtonType} from "../../../../../gd-components/buttons/gd-button/gd-button-ui5-new";
import ProjectUserFull from "../../../../../model2/project-user/project-user-full";
import FormModel from "../../../../../gd-form/common/form-model-manager";
import UserAssignment from "../../../model/user-assignment";
import ModalProjectUserActions from "../../actions/actions";
import UserAssignment_Collection from "../../../model/collection";

type Props = {
    reassignType        : USER_VIEW_TYPE
    userAssignments     : UserAssignment_Collection
    projectUser         : ProjectUserFull
    reasonCantDelete    : string
    actions             : ModalProjectUserActions
    onCloseModal        : callback
}

export default class ReassignUserView extends React.Component<Props> {

    public model            : UserAssignment
    public form             : FormModel
    public userOptions      : Options

    constructor(props: Props) {
        super(props);

        this.model = !!this.props.userAssignments && !this.props.userAssignments.isEmpty ? this.props.userAssignments.models?.[0] : new UserAssignment({})

        this.form = new FormModel(this.model, {
            onSubmit: this.onSubmit,
        });

        this.userOptions = _(gd.session.projectUsers.filterByProjectNotReadOnly(this.props.projectUser.projectId).models)
            .map(projectUser=>({
                value: projectUser.user.id,
                label: projectUser.user.name
            }))
            .filter(option=>option.value !== this.props.projectUser.userId)
            .value();
    }

    onSubmit = (result: ReassignToUserType) => {

        this.props.userAssignments.reset([new UserAssignment({
            userId                  : this.props.projectUser.userId,
            tasksReassignUserId     : result.tasksReassignUserId,
            eventsReassignUserId    : result.eventsReassignUserId,
            projectReassignUserId   : result.projectReassignUserId,
        })])

        this.props.actions.reassignUserItems(this.props.userAssignments, this.props.reassignType)
    }

    getInfo() {
        let res;

        const project: ProjectSession | null = gd.session.projects.get(this.props.projectUser.projectId);
        const user: User | null = gd.session.users.get(this.props.projectUser.userId);

        switch (this.props.reassignType) {
            case USER_VIEW_TYPE.REASSIGN_DELETE:
                res = (
                    <div className="ui5-plate plate-error flex-row-left-top p-l-15 p-r-15">
                        <div className="flex-row-left-top w-60">
                            <div className="i5-emergency-solid ui5-color-red fs-32 m-t-4"></div>
                        </div>
                        <div>
                            <p>You are about to delete <b>{user?.name}</b> from <b>{project?.name}</b> project.</p>
                            <p className="m-t-10">This user has open items that you need to re-assign to another project
                                user before deleting.</p>
                        </div>
                    </div>
                );
                break;
            case USER_VIEW_TYPE.REASSIGN_ACCESS:
                res = (
                    <div className="ui5-plate plate-error flex-row-left-top p-l-15 p-r-15">
                        <div className="flex-row-left-top w-60">
                            <div className="i5-emergency-solid ui5-color-red fs-32 m-t-4"></div>
                        </div>
                        <div>
                            <p>You are about to set the read-only access level
                                for <b>{user?.name}</b> in <b>{project?.name}</b> project.</p>
                            <p className="m-t-10">Please re-assign active tasks/events/projects if applicable and click
                                reassign button.</p>
                        </div>
                    </div>
                );
                break;
        }
        return res;
    }

    renderContent = ()=> {

        const {canDelete, reasonCantDelete} = this.props.actions.checkDelete();

        if (!canDelete) {
            return (
                <div className="ui5-txt-red ui5-txt-not-important-small m-t-20 m-r-20" style={{marginLeft: 36}}>
                    {reasonCantDelete}
                </div>
            )
        }

        return (
            <div className="p-l-10 p-r-35 p-b-25 m-l-1">
                <Form>
                    <ReassignUserTasks form         = {this.form}
                                       tasks        = {this.model.tasks}
                                       userOptions  = {this.userOptions}/>
                    <ReassignUserEvents form        = {this.form}
                                        events      = {this.model.events}
                                        userOptions = {this.userOptions}/>
                    <ReassignUserProjects form          = {this.form}
                                          projects      = {this.model.projects}
                                          userOptions   = {this.userOptions}/>
                </Form>

            </div>
        )
    }

    render() {

        const user: User | null = gd.session.users.get(this.props.projectUser.userId);
        const {canDelete} = this.props.actions.checkDelete();

        let title = '';
        let submitLabel = '';

        switch (this.props.reassignType) {
            case USER_VIEW_TYPE.REASSIGN_DELETE:
                title = 'Delete Users';
                submitLabel = 'Reassign & Delete';
                break;
            case USER_VIEW_TYPE.REASSIGN_ACCESS:
                title = 'Update Users';
                submitLabel = 'Reassign & Update';
                break;
        }

        return (
            <div className="flex-columns-top-bottom h-100p">

                <div className="flex-row-right-center">
                    <div className="i5-delete m-t-10 m-r-10" onClick={this.props.onCloseModal}/>
                </div>

                <div className="ui5-title-app-name p-l-25 p-r-25 m-b-15">
                    {title}
                </div>

                <VScroll style={{ height: "calc(100% - 150px)"}}>
                    <div className="big-panel p-l-25 p-r-25 p-t-10">

                        {canDelete && this.getInfo()}

                        <div className="flex-row-left-center m-t-25">
                            <UserIcon className="m-r-10" size="26" userId={this.props.projectUser.userId}/>
                            <div className="ui5-title-small">{user?.name}</div>
                        </div>

                        {this.renderContent()}

                    </div>
                </VScroll>
                <div className="modal-submit flex-row-center-top fl-gap-8">
                    <ButtonSubmit className = {Classes("m-r-15", {"red": canDelete})}
                                  form      = {this.form}
                                  disabled  = {!canDelete}
                                  label     = {submitLabel}/>
                    <Button label   = "No, cancel"
                            type    = {canDelete ? ButtonType.WHITE : ButtonType.SECONDARY}
                            onClick = {this.props.onCloseModal}/>
                </div>
            </div>
        );
    }
}
